/**
 * LEGACY: DirectMessage REST client — targeting /messages/direct/* endpoints.
 *
 * This file is kept as a backup while the Phase F DirectMessage-to-Message
 * migration script (story 24-2: prisma:migrate-dm) is being verified in
 * production.  Once the migration is confirmed complete and the legacy
 * DirectMessage table has been dropped, this file should be deleted.
 *
 * TODO(phase-f-cleanup): Remove this file after DirectMessage migration is
 * verified in production.  New code should import from src/api/chat.js instead.
 *
 * Replaced by: src/api/chat.js (getChatRooms, getRoomMessages, sendRoomMessage)
 * Story reference: Epic 25 / 25-3c
 */
import { apiClient } from './client';

/**
 * Send direct message to student
 * @param {object} body - { recipientId, content, courseId? }
 */
export async function sendDirectMessage(body) {
  const { data } = await apiClient.post(`/messages/direct`, body);
  return data;
}

/**
 * Get direct message conversation
 * @param {string} recipientId
 * @param {{ page?, limit? }} params
 */
export async function getMessageConversation(recipientId, params = {}) {
  // Always send page/limit. Omitting them makes the backend's implicit query
  // conversion hand the service NaN, which Prisma rejects with a 500 — sending
  // explicit values keeps this working against backends that predate the fix.
  const { data } = await apiClient.get(`/messages/direct/${recipientId}`, {
    params: { page: 1, limit: 50, ...params },
  });
  return data;
}

/**
 * Get all direct message conversations
 * @param {{ page?, limit?, search? }} params
 */
export async function getMessageConversations(params = {}) {
  const { data } = await apiClient.get(`/messages/direct`, {
    params: { page: 1, limit: 20, ...params },
  });
  return data;
}

/**
 * Mark message as read
 * @param {string} messageId
 */
export async function markMessageAsRead(messageId) {
  const { data } = await apiClient.put(`/messages/${messageId}/read`);
  return data;
}

/**
 * Delete a message
 * @param {string} messageId
 */
export async function deleteMessage(messageId) {
  const { data } = await apiClient.delete(`/messages/${messageId}`);
  return data;
}
